import { ShieldAlert, ShieldCheck } from 'lucide-react';
import type { ReactElement } from 'react';

import { verifyErrorText, verifyOutcome } from '../signature-verify';
import { useVerifySignature } from '../use-verify-signature';
import { formatDateTime } from '@/lib/time';

// "Verificar integridad" del sello (spec 2026-10-14 §6 D3/D4): a demanda, con el
// resultado en la tarjeta, la hora de la verificación y "Verificar de nuevo".

export function SealVerification({ signatureId }: { signatureId: string }): ReactElement {
  const verify = useVerifySignature(signatureId);
  const busy = verify.isPending;
  const outcome = verify.data ? verifyOutcome(verify.data.result) : null;
  const done = verify.isSuccess || verify.isError;

  return (
    <div className="seal-verify">
      {verify.isError ? (
        <div className="seal-verify-result bad" role="alert">
          <ShieldAlert aria-hidden="true" />
          <div>
            <b>No se pudo verificar la firma</b>
            <p>{verifyErrorText(verify.error)}</p>
          </div>
        </div>
      ) : null}
      {outcome !== null && verify.data ? (
        <div
          className={outcome.valid ? 'seal-verify-result ok' : 'seal-verify-result bad'}
          role={outcome.valid ? 'status' : 'alert'}
        >
          {outcome.valid ? <ShieldCheck aria-hidden="true" /> : <ShieldAlert aria-hidden="true" />}
          <div>
            <b>{outcome.title}</b>
            {outcome.problems.length > 0 ? (
              <ul>
                {outcome.problems.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
            ) : null}
            <p>{outcome.detail}</p>
            <p className="soft">Verificada el {formatDateTime(verify.data.at.toISOString())}</p>
          </div>
        </div>
      ) : null}
      <button
        type="button"
        className="btn mut sm"
        aria-busy={busy}
        aria-disabled={busy}
        onClick={() => {
          if (!busy) {
            verify.mutate();
          }
        }}
      >
        <ShieldCheck aria-hidden="true" size={14} strokeWidth={1.9} />
        {busy ? 'Verificando…' : done ? 'Verificar de nuevo' : 'Verificar integridad'}
      </button>
    </div>
  );
}
